import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { updateUser } from '../services/userService';

/**
 * Schreibt die gewählte Sprache ins Nutzerprofil (user.language), damit Backend,
 * Push und E-Mails die Sprache kennen. Die lokale Wahl (Gerät) hat Vorrang.
 * Rendert nichts; sitzt innerhalb von AuthProvider und LanguageProvider.
 */
const LanguageProfileSync: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const { lang } = useLanguage();

  useEffect(() => {
    if (!isAuthenticated || !user) return;
    const profileLang = typeof (user as any).language === 'string' ? (user as any).language : null;
    if (profileLang === lang) return;
    updateUser({ language: lang } as any).catch(() => {
      /* nicht kritisch – nächster Versuch beim nächsten Wechsel/Login */
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, lang, (user as any)?.id]);

  return null;
};

export default LanguageProfileSync;
